import MainMenuContainer from "../../MainMenuContainer";
import styled from "styled-components";
import { Logo } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const HeaderStyled = styled.header`
  padding-top: ${props => props.theme.spacing.medium};
`;
console.log(Logo)
export const LogoStyled = styled(Logo)`

`;
console.log(styled(Logo))
export const ImageStyled = styled.img`
  position: absolute;
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: ${
      props.theme.baseLayoutPaddingBs
    }%`};

  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ?
    `margin-right : calc(-${props.theme.components.carousel.slideMargin.default} * 20)`
    :
    `margin-left : calc(${props.theme.components.carousel.slideMargin.default} * 10)`
  };

    transform: translate(-50%, -50%);
    margin-top: 1rem;
    width: 11vw;
`;


/* prettier-ignore */
export const MainMenuContainerStyled = styled(MainMenuContainer)`
  opacity:0;
  ${HeaderStyled}.isActiveMenu & {
    opacity:1;
  }
`;
